import React, { useContext, useState } from 'react';
import UserContext from '../../../context/userContext';
import {
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  VStack,
  Button,
} from '@chakra-ui/react';
import CustomInputSelect from '../../Common/InputSelect';
import AlertWarning from '../../Common/AlertWarning';

import { cambiarActivoPostventa } from '../../../services/Admin/cambiarActivoPostventa';
import { useTranslation } from 'react-i18next';

export default function CambiarEstatusActivo({
  loadPostventas,
  postVentasActivos,
  selectedPostventa,
  statusToChange,
  isOpenDialogConfirm,
  onCloseDialogConfirm,
}) {
  const { t } = useTranslation()
  const { user } = useContext(UserContext);
  const {
    isOpen: isOpenAlertError,
    onOpen: onOpenAlertError,
    onClose: onCloseAlertError,
  } = useDisclosure();
  const cancelRef = React.useRef();

  const [selectedPostventaToTransfer, setSelectedPostventaToTransfer] =
    useState('');
  const [errorFromServer, setErrorFromServer] = useState({
    error: true,
    msg: '',
  });
  const [inputErrors, setInputErrors] = useState({
    idPostventaToTransfer: '',
  });

  //validaciones del formularios
  const validateForm = () => {
    //solo hace la validacion si se desea inactivar al postventa
    if (!statusToChange && selectedPostventa?.titulares?.length > 0) {
      const errors = {
        idPostventaToTransfer:
          selectedPostventaToTransfer === '' ? t('REQUIRED_FIELD') : '',
      };

      setInputErrors(errors);
      return Object.values(errors).every((error) => error === '');
    }
    return true;
  };

  //cambiar estatus activo
  const handleConfirmStatusChange = () => {
    if (validateForm()) {
      const newStatus = statusToChange.toString(); //false inactivo... true activo
      const numeroTitulares = selectedPostventa.titulares.length.toString();

      cambiarActivoPostventa(
        user.id,
        selectedPostventa.id,
        numeroTitulares,
        newStatus,
        selectedPostventaToTransfer
      )
        .then((res) => {
          if (res.status === 200) {
            loadPostventas();
            onCloseDialogConfirm();
          } else {
            setErrorFromServer({
              error: true,
              msg: t('ERROR_OCCURRED'),
            });
            onCloseDialogConfirm();
            onOpenAlertError();
          }
        })
        .catch((err) => {
          setErrorFromServer({ error: true, msg: err.response.data.error });
          onCloseDialogConfirm();
          onOpenAlertError();
        });
    }
  };

  //seleccionar un agente postventa para transferir titulares
  const handleSelectPostventaToTransfer = (e) => {
    setSelectedPostventaToTransfer(e.target.value);
    setInputErrors((prevErrors) => ({
      ...prevErrors,
      idPostventaToTransfer: '',
    }));
  };
  return (
    <>
      <AlertWarning
        isOpen={isOpenAlertError}
        onClose={onCloseAlertError}
        header={t('ERROR_STATUS_CHANGE')}
        msg={errorFromServer.msg}
      />
      <AlertDialog
        isOpen={isOpenDialogConfirm}
        leastDestructiveRef={cancelRef}
        onClose={onCloseDialogConfirm}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader
              fontSize="lg"
              fontWeight="bold"
            >
              {
                t('STATUS_CHANGE_POSTSELL')
              }
            </AlertDialogHeader>

            <AlertDialogBody>
              <VStack
                spacing={2}
                textAlign="left"
              >
                <div style={{ width: '100%' }}>
                  <p>
                    {t('ABOUT_TO')}{' '}
                    <b>
                      {statusToChange ?  t('ACTIVATE') : t('DEACTIVATE')}
                    </b> {t('AGENT')}{' '}
                    <b>
                      {selectedPostventa.nombre +
                        ' ' +
                        selectedPostventa.apellidos}
                    </b>
                    .
                  </p>
                </div>
                {!statusToChange &&
                  selectedPostventa?.titulares?.length > 0 && (
                    <div>
                      {t('TRANSFER_WARNING')}{' '}
                      <b>{selectedPostventa.titulares.length}</b> {t('PARTNERS')}{' '}
                      <b>
                        {selectedPostventa.nombre +
                          ' ' +
                          selectedPostventa.apellidos}
                      </b>
                      .
                      <CustomInputSelect
                        label={t('AVAILABLE_AGENTS')}
                        name="idPostventaToTransfer"
                        disabled={false}
                        onChange={handleSelectPostventaToTransfer}
                        value={selectedPostventaToTransfer}
                        error={inputErrors.idPostventaToTransfer}
                        options={[
                          { value: '', text: t('SELECT_AGENT') },
                          ...postVentasActivos
                            .filter(
                              (postventa) =>
                                postventa.id !== selectedPostventa.id
                            )
                            .map((postventa) => ({
                              value: postventa.id,
                              text: `${postventa.nombre} ${postventa.apellidos}`,
                            })),
                        ]}
                      />
                    </div>
                  )}
                <div style={{ width: '100%' }}>
                  <p>{t('CONFIRM_STATUS_CHANGE')}</p>
                </div>
              </VStack>
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button
                colorScheme="yellow"
                variant="outline"
                ml={3}
                ref={cancelRef}
                onClick={onCloseDialogConfirm}
              >
                {t('CANCEL')}
              </Button>
              <Button
                colorScheme="facebook"
                ml={3}
                ref={cancelRef}
                onClick={handleConfirmStatusChange}
              >
                {t('ACCEPT')}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}
